__webpack_require__.p = "/React_bank_landing_page/";